import React, { useContext, useEffect } from 'react';
import { Box, Typography, CssBaseline, Card, Button, useTheme } from '@mui/material';
import WalletCard from './WalletCard.component'; // Assuming WalletCard.jsx is in the same folder
import { WalletsContext } from '../../state/context/wallets.context';

function WalletList({ }) { // JS version, setting default maxHeight
    const { state, getWallets, loading } = useContext(WalletsContext);
    const wallets = state.wallets; // Accessing wallets from context

    useEffect(() => {
        // Fetch wallets when the component mounts
        getWallets();
    }, []);



    function downloadArrayAsJson() {
        try {
            const dataArray = wallets;
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const dateString = `${ year }-${ month }-${ day }`;
            const filename = `flokitools-wallet-${ dateString }.json`;

            const jsonData = JSON.stringify(dataArray, null, 2);
            const blob = new Blob([jsonData], { type: 'application/json' });
            const url = URL.createObjectURL(blob);

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = url;
            link.download = filename; // Set the desired filename for the download

            // Programmatically click the link to trigger the download
            document.body.appendChild(link);
            link.click();

            // Clean up the temporary URL object
            URL.revokeObjectURL(url);
            document.body.removeChild(link);

            console.log(`Data download initiated as ${ filename }`);
            return true;
        } catch (error) {
            console.error('Error initiating JSON download:', error);
            return false;
        }
    }

    if (!wallets || wallets.length === 0) {
        return (
            <Card sx={{
                width: '100%',
                margin: 'auto',
                mt: 3,
                p: 2,
                background: "none",
                borderRadius: 2,
                border: '1px solid rgba(255, 255, 255, 0.12)',
                minHeight: "70vh",

            }}
            >
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', }}>
                    Wallet List
                </Typography>
                <Typography color='#b0b0b0'>No wallets added yet.</Typography>

            </Card>
        );
        return (
            <>
                <CssBaseline />
                <Box sx={{ textAlign: 'center', mt: 5, color: 'text.secondary' }}>
                    <Typography>No wallets added yet.</Typography>
                </Box>
            </>
        );
    }

    return (

        <Card sx={{
            maxWidth: "100%",
            margin: 'auto',
            mt: 3,
            p: 2,
            background: "none",
            borderRadius: 2,
            border: '1px solid rgba(255, 255, 255, 0.12)',
            minHeight: "70vh",
        }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                    Wallet List
                </Typography>

                <Button
                    variant="outlined"
                    // color="primary"
                    onClick={downloadArrayAsJson}
                    sx={{
                        borderColor: "secondary.main",
                    }}

                >
                    Download Wallets
                </Button>

            </Box>

            {/* Inner container for the scrollable list */}
            <Box
                sx={{
                    maxHeight: "70vh", // Use the prop for max height (e.g., '70vh', '500px')
                    overflowY: 'auto', // Enable vertical scrolling only when needed
                    overflowX: 'hidden', // Prevent horizontal scrolling
                    // Add some padding to the right to prevent scrollbar overlap issue
                    pr: 1, // Padding right for scrollbar space
                    // Add some padding to the bottom if needed
                    pb: 1,
                    // Optional: Customize scrollbar appearance (Webkit browsers)
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)', // Lighter track
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(255, 255, 255, 0.3)', // Dimmer thumb
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.5)', // Brighter on hover
                        }
                    }
                }}
            >
                {/* Render the list of cards inside the scrollable container */}
                {wallets.map((wallet) => (
                    <WalletCard
                        key={wallet.id} // Essential for list rendering
                        wallet={wallet}
                    />
                ))}
            </Box>
        </Card>
    );
}


export default WalletList; 
